<div class="main-container">
  <mat-card appearance="outlined">
    <mat-card-title>Role Information</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr>
          <th><strong>Name</strong></th>
          <td>{{displayModel.name}}</td>
        </tr>
        <tr>
          <th><strong>Description</strong></th>
          <td>{{displayModel.description}}</td>
        </tr>
        <tr>
          <th><strong>Is System</strong></th>
          <td>{{displayModel.isSystem ? 'Yes' : 'No'}}</td>
        </tr>
        <tr>
          <th><strong>Created On</strong></th>
          <td>{{displayModel.createdOn | dateTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        <tr>
          <th><strong>Updated On</strong></th>
          <td>{{displayModel.updatedOn | dateTime: 'M/dd/yyyy hh:mm a'}}</td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <mat-card-actions *ngIf="!displayModel.isSystem && hasEditAccess">
      <a routerLink="{{editUrl}}" mat-raised-button color="primary" matTooltip="Edit Role">Edit</a>
    </mat-card-actions>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-title>Permissions</mat-card-title>
    <mat-card-content>
      <table class="table mt-4">
        <tbody>
        <tr *ngFor="let module of modules">
          <th>
            <strong>{{module.name}}</strong>
            <span class="form-text text-muted">{{module.description}}</span>
          </th>
          <td>
            <ng-container *ngFor="let permission of module.permissions">
                  <span *ngIf="permission.selected">
                    {{permission.name}}<br>
                  </span>
            </ng-container>
            <ng-container *ngFor="let permission of module.additionalPermissions">
                  <span style="display: block; margin-top: 10px;">
                    <label class="text-muted" style="display: block;">{{permission.name}}:</label>
                    {{permission.value}}
                  </span>
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
    <mat-card-actions *ngIf="!displayModel.isSystem && hasEditAccess">
      <a routerLink="{{editUrl}}" mat-raised-button color="primary" matTooltip="Edit Role">Edit</a>
    </mat-card-actions>
  </mat-card>
</div>
